import { useNavigate } from "react-router-dom";

export default function ProfileStats() {
  const navigate = useNavigate();
  return <div className="flex-1 px-4 py-4">
    <div className="flex items-center gap-2 mb-4">
      <button onClick={() => navigate(-1)}
        className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center cursor-pointer shrink-0">
        <i className="ri-arrow-left-s-line text-foreground-600 text-sm" />
      </button>
      <h1 className="text-base font-bold text-foreground-950">使用统计</h1>
    </div>
    <div className="bg-white rounded-xl p-4 border border-background-200/60">
      {[
        { label: "AI 研判", value: 286, icon: "ri-ai-line" },
        { label: "AI 对话", value: 89, icon: "ri-chat-3-line" },
        { label: "研报生成", value: 12, icon: "ri-file-list-3-line" },
        { label: "策略管理", value: 5, icon: "ri-function-line" },
      ].map((s) => (
        <div key={s.label} className="flex items-center justify-between py-3 border-b border-background-100 last:border-b-0">
          <div className="flex items-center gap-2"><i className={`${s.icon} text-foreground-400`} /><span className="text-sm text-foreground-600">{s.label}</span></div>
          <span className="text-sm font-semibold text-foreground-950">{s.value}</span>
        </div>
      ))}
    </div>
  </div>;
}
